// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__merrieWeatherBlackItalic_61ca6f', '__merrieWeatherBlackItalic_Fallback_61ca6f', s, e, r, i, f","fontStyle":"normal"},"className":"__className_61ca6f"};